"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Max save integer value
 *
 * @ignore
 * @type {number}
 */

var MAX_SAFE_INTEGER = exports.MAX_SAFE_INTEGER = 0x1fffffffffffff;